import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { of, tap, catchError } from 'rxjs';

import { ResendErrorsEnum } from '@shared/verification/enum';
import { resendErrorAlerts } from '../constants';
import { ApiClientService } from '@tablesready/api-client';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Injectable()
export class ResendVerificationService {
  private readonly basePath = '/verify';
  constructor(
    private readonly http: ApiClientService,
    private readonly router: Router,
    private readonly alertService: AlertsService
  ) {
  }

  resend(accountId: string) {
    return this.http.post(`${this.basePath}/resend`, {accountId})
      .pipe(
        tap(() => this.alertService.addSuccess(
          'Check your email and click to verify your account.',
          'Success: ',
        )),
        catchError(({error}) => {
          let _error = ResendErrorsEnum.unknown;
          const knownErrors = [ResendErrorsEnum.noUser, ResendErrorsEnum.alreadyVerified, ResendErrorsEnum.rateLimited];
          if (knownErrors.includes(error.error)) {
            _error = error.error;
          }

          this.alertService.addError(resendErrorAlerts[_error].body, resendErrorAlerts[_error].heading);
          if (![ResendErrorsEnum.unknown, ResendErrorsEnum.rateLimited].includes(_error)) {
            this.router.navigate(['/login']);
          }

          return of(null);
        }),
      );
  }
}
